export enum AlertType {
    TravelTime,
    TravelSpeed
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/alertType.ts